export const RoommateInfoValidationSchema = {
    roommate_name: [
        { rule: "required", message: "Name required" },
    ],
    email: [
        { rule: "required", message: "Email address required" },
        { rule: "email", message: "Email is invalid" }
    ],
}